"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateAnalyticDto = void 0;
class CreateAnalyticDto {
    area_code;
    asn;
    displayId;
    forwardedFor;
    ip;
    ips;
    latitude;
    longitude;
    mediaId;
    method;
    organization_name;
    organization;
    originalUrl;
    referrer;
    reqId;
    ua;
    userAgent;
    // Campos geográficos adicionales
    continent_code;
    region;
    accuracy;
    country;
    city;
    timezone;
    country_code;
    country_code3;
    // Campo de solicitud
    request;
    // Información del navegador
    browser;
    // Información de CPU
    cpu;
    // Información del dispositivo
    device;
    // Información del motor de renderizado
    engine;
    // Información del sistema operativo
    os;
}
exports.CreateAnalyticDto = CreateAnalyticDto;
